// import SpeedBoad from "../images/speedboat/boatVlore1.jpeg";
// import SpeedBoad from "../public/images/speedboat/boatVlore3.jpeg";
import { FaStar } from "react-icons/fa";
import { GiSpeedBoat } from "react-icons/gi";
import { Link } from "react-router-dom";
import { speedBoatData } from "../data/dummyData";
import SEO from "../components/common/SEO";
import NavFilters from "../components/common/NavFilters";
import {
  getSpeedBoatTourSchema,
  getBreadcrumbSchema,
} from "../utils/structuredData";
// import { useState } from "react";
// import SpeedBoatBookingModal from "../components/bookings/SpeedBoatBookingModal";

const SpeedBoat = () => {
  const SpeedBoad = "images/speedboat/speedboatNewWhite3.jpeg";

  const breadcrumbs = [
    { name: "Home", path: "/" },
    { name: "Boat Tours", path: "/boat-tours" },
  ];

  const structuredData = [
    getSpeedBoatTourSchema(),
    getBreadcrumbSchema(breadcrumbs),
  ];
  // OLD MODAL CODE - Commented out
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedBoat, setSelectedBoat] = useState(null);
  //
  // const handleBookClick = (e, boat) => {
  //   e.preventDefault();
  //   setSelectedBoat(boat);
  //   setIsModalOpen(true);
  // };
  //
  // const handleCloseModal = () => {
  //   setIsModalOpen(false);
  //   setSelectedBoat(null);
  // };

  // Show all boat tours (not jet-ski, which has its own page) — bayliner hidden temporarily
  const filteredSpeedBoatData = speedBoatData.filter(
    (boat) => boat.slug === "quicksilver-tour",
  );

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <SEO
        title="Speedboat Tours Durrës Albania | Shipwreck, Beach & Coastal – SeaPulse"
        description="Experience thrilling speedboat tours in Durrës, Albania. Explore a real WWII shipwreck, discover secret hidden beaches, or cruise the stunning Albanian Riviera. QuickSilver 805 & Bayliner boats. From €50/person. Min 2 guests."
        keywords="speedboat tour Durrës, speedboat Albania, QuickSilver boat tour Albania, shipwreck tour Durrës, WWII shipwreck boat Albania, coastal boat tour Albania, Bayliner water sports Durrës, hidden beach tour Albania, sea tour Durrës, boat excursion Albania, Albanian coast speedboat, Adriatic speedboat tour, boat adventures Durrës, sea trip Albania, boat rental Durrës, speedboat hire Albania"
        canonical="/boat-tours"
        structuredData={structuredData}
      />
      {/* Hero Banner */}
      <div className="relative h-[450px] md:h-[500px] lg:h-[550px] flex items-center justify-center overflow-hidden">
        <img
          src={SpeedBoad}
          alt="Speed Boat Adventures"
          className="absolute inset-0 w-full h-full object-cover brightness-90 dark:brightness-75"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/70 via-cyan-800/60 to-blue-600/50" />
        <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 max-w-5xl mx-auto">
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-sm font-semibold px-5 py-2 rounded-full mb-6 border border-white/30 flex items-center gap-2">
            <GiSpeedBoat className="text-xl" /> Boat Tours
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-white drop-shadow-2xl mb-6 leading-tight">
            Boat Tours Adventures
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/95 max-w-3xl leading-relaxed drop-shadow-lg mb-8">
            Experience the thrill of Albania's stunning Adriatic coastline with
            our boat tours
          </p>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-3 text-white/90 text-xs sm:text-sm">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <span>⭐</span>
              <span className="font-semibold">5.0 Rating</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <span>🛡️</span>
              <span className="font-semibold">Licensed & Insured</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <span>🎖️</span>
              <span className="font-semibold">Expert Captains</span>
            </div>
          </div>
        </div>
      </div>

      <NavFilters />

      {/* Tours Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-4">
            Available Boat Tours
          </h2>
          <p className="text-base sm:text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto leading-relaxed">
            Choose from our selection of premium boat experiences along the
            Albanian coast
          </p>
        </div>
        <div className="flex flex-col gap-6">
          {filteredSpeedBoatData.map((boat) => {
            const {
              id,
              name,
              rating,
              image,
              number_of_reviews,
              price,
              priceLabel,
              description,
              time,
            } = boat;

            return (
              <div
                key={id}
                className="group bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden hover:border-cyan-400 dark:hover:border-cyan-500 hover:-translate-y-1"
              >
                <div className="flex flex-col lg:flex-row">
                  {/* Image Section */}
                  <div className="relative w-full lg:w-80 h-64 lg:h-72 flex-shrink-0 overflow-hidden">
                    <img
                      src={image}
                      alt={name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                    <div className="absolute top-4 left-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-sm font-bold px-4 py-2 rounded-full shadow-xl">
                      ⚡ Featured
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="flex-1 p-6 lg:p-8 flex flex-col">
                    <div className="flex-1">
                      <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-cyan-600 dark:group-hover:text-cyan-400 transition-colors duration-300">
                        {name}
                      </h3>
                      <p className="text-base text-gray-600 dark:text-gray-300 mb-5 leading-relaxed line-clamp-3">
                        {description}
                      </p>

                      <div className="flex flex-wrap items-center gap-4 mb-6">
                        <div className="flex items-center gap-2 bg-yellow-50 dark:bg-yellow-900/20 px-3 py-2 rounded-lg">
                          <FaStar className="text-yellow-500" />
                          <span className="font-bold text-gray-900 dark:text-white">
                            {rating}
                          </span>
                          <span className="text-sm text-gray-600 dark:text-gray-400">
                            ({number_of_reviews} reviews)
                          </span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
                          <span className="text-lg">⏱️</span>
                          <span className="font-medium">{time}</span>
                        </div>
                      </div>
                    </div>

                    {/* Price & Action Section */}
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-5 border-t border-gray-200 dark:border-gray-700">
                      <div>
                        <span className="text-sm text-gray-500 dark:text-gray-400 block mb-1 font-medium">
                          Starting from
                        </span>
                        <div className="text-4xl font-extrabold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
                          €{price}
                        </div>
                        <span className="text-sm text-gray-500 dark:text-gray-400">
                          {priceLabel || "per person"}
                        </span>
                      </div>
                      <Link
                        to={`/${boat.slug}/tour-details`}
                        className="w-full sm:w-auto"
                      >
                        <button className="w-full sm:w-auto bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl group-hover:scale-105 text-base">
                          Book This Tour →
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SpeedBoat;
